export default __webpack_public_path__ + "static/media/chat-empty-icon.c1eee61e.svg";